import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsIssues from '@atlassian/jira-navigation-apps-sidebar-global-settings-issues/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { customFieldsDirectoryResource } from '@atlassian/jira-router-resources-admin-pages-custom-fields-directory/src/services/index.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { globalSettingsCustomFieldsRoute } from '@atlassian/jira-router-routes-global-settings-custom-fields-routes/src/globalSettingsCustomFieldsRoute.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@atlassian/jira-router-resources-post-office/src/services/index.tsx';
import CustomFields, {
	LazyCustomFieldsDirectoryAdmin,
} from './ui/admin-pages/custom-fields-directory/index.tsx';

export const globalSettingsCustomFieldsRouteEntry = createEntry(
	globalSettingsCustomFieldsRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.custom-fields-directory',
		component: CustomFields,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_ISSUES_SETTINGS,
			menuId: MENU_ID.SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsIssues,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			customFieldsDirectoryResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyCustomFieldsDirectoryAdmin],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-global-settings-custom-fields-entries/src/globalSettingsCustomFieldsRouteEntry.tsx',
				whichExportToUse: 'globalSettingsCustomFieldsRouteEntry',
			},

			enabled: true,
		},
	}),
);
